import { render } from "./검진유의사항.vue?vue&type=template&id=083d0152"
import script from "./검진유의사항.vue?vue&type=script&lang=js"
export * from "./검진유의사항.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__